import { api_base_url, request } from '../utils';

const BASE = (api_base_url || '').replace(/\/+$/, '');

export class BondaWalletService {
  static ENDPOINT = `${BASE}/bondaWallet`;

  static async assign(amount, interactions = [], exchangeProductId = null, exchangeScore = 0) {
    return request({
      url: `${this.ENDPOINT}/assign`,
      method: 'POST',
      body: {
        Amount: Number(amount),
        ExchangeProductId: exchangeProductId,
        ExchangeScore: Number(exchangeScore || 0),
        Interactions: interactions.map((interaction) => ({
          Id: interaction.id,
          Quantity: Number(interaction.quantity),
        })),
      },
      responseType: 'text',
    });
  }
}

export default BondaWalletService;
